import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { SurveyComposerPage } from '@/features/surveys';

export const Route = createFileRoute('/surveys_/new')({
  component: SurveyNewRoute,
});

function SurveyNewRoute(): ReactNode {
  return (
    <AuthGuard>
      <SurveyComposerPage />
    </AuthGuard>
  );
}
